import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({
  title = "Symphony IT - Expert IT Services & Solutions in the DMV Area",
  description = "Symphony IT provides managed IT services, cybersecurity, IT consulting, and technical support for businesses and homes in the DMV area. Orchestrate. Simplify. Secure.",
  name = "Symphony IT",
  type = "website",
  url = "https://symphony-it.com/"
}) => {
  return (
    <Helmet>
      {/* Standard metadata tags */}
      <title>{title}</title>
      <meta name="description" content={description} />

      {/* Facebook tags */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />

      {/* Twitter tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />

      {/* Canonical URL */}
      <link rel="canonical" href={url} />
    </Helmet>
  );
};

export default SEO;
